import { createApi } from '@reduxjs/toolkit/query/react';
import { SEARCH_API_URL } from '../../utils/apiEndpoints';
import fetchQuery from '../../apiClient/fetchQuery';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: fetchQuery,
  endpoints: (builder) => ({
    fetchSearchResults: builder.query({
      query: ({ query, size = 10, from = 0, searchType = '', filterType = '' }) => ({
        url: SEARCH_API_URL,
        params: {
          q: query,
          size,
          from,
          search_type: searchType,
          filter: filterType,
        },
      }),
      transformResponse: (response) => ({
        docs: response.data.documents || [],
        workspaces: response.data.workspaces || [],
        total: response.data.total || 0,
        totalDocuments: response.data.total_documents || 0,
        totalWorkspaces: response.data.total_workspaces || 0,
      }),
    }),
  }),
});

export const { useLazyFetchSearchResultsQuery } = searchApi;
